<template>
  <div class="address-page">
    <div class="page-content" v-if="dataModels.length">
      <div class="header">
        <div class="add-box">
          <div class="add-btn s-btn btn-blue is-plain" @click="addAddress">+ 新增收货地址</div>
        </div>
      </div>
      <div class="address-list">
        <div class="address-item-box" v-for="(item, index) in dataModels" :key="index">
          <div class="default-flag" v-if="item.is_default">默认地址</div>
          <div class="item-header">
            <div class="item-name">{{item.addressee}}</div>
            <div class="item-phone">{{item.mobile_phone}}</div>
          </div>
          <div class="item-content">
            <div class="item-address">{{getAddress(pcds, item)}}</div>
            <div class="item-email">
              <img class="icon" src="../../../assets/imgs/new-user/icon-email.png" alt="">
              <div class="text">{{item.email}}</div>
            </div>
          </div>
          <div class="item-footer">
            <div class="handler-item" @click="setDefault($event, item)" v-if="!item.is_default">
              <div class="icon default"></div>
              <div class="text">设为默认</div>
            </div>
            <div class="handler-item" @click="editAddress($event, item)">
              <div class="icon edit"></div>
              <div class="text">编辑</div>
            </div>
            <div class="handler-item" @click="delModel($event, item, index)">
              <div class="icon delete"></div>
              <div class="text">删除</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="no-address" v-else>
      <img class="nodata-img" src="../../../assets/imgs/new-user/address-nodata.png" alt="">
      <div class="nodata-text">暂无地址</div>
      <div @click="addAddress" class="add-btn s-btn btn-blue">+ 新增收货地址</div>
    </div>
    <add-or-edit-address-dialog
      :show.sync="addressDialog.visible"
      :address-info="addressDialog.addressInfo"
      :title="addressDialog.type=== 'add' ? '新增地址' : '编辑地址'"
      :show-set-default="true"
      @success="handleEditAddressSuccess"
    ></add-or-edit-address-dialog>

  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import utils from '../../../libs/utils';
import Http from '../../../libs/http';
import addressUtils from '../../../libs/address-utils';
import pcdService from '../../../services/pcd-service';
import AddOrEditAddressDialog from '../../../components/address/add-or-edit-address-dialog.vue';

export default {
  components: {
    AddOrEditAddressDialog,
  },
  data() {
    return {
      pcds: {},
      dataModels: [],
      addressDialog: {
        visible: false,
        type: 'add',
        addressInfo: null,
      },
    };
  },

  created() {
    this.getData();
    pcdService.getPcd().then(pcds => (this.pcds = pcds)).catch((e) => {
      if (e) console.log(e);
    });
  },

  methods: {
    getData() {
      Http.post('/peer_address_total_query', {}).then((data) => {
        this.dataModels = data.result;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 新增地址
    addAddress(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.addressDialog.addressInfo = null;
      this.addressDialog.type = 'add';
      this.addressDialog.visible = true;
    },

    // 编辑地址
    editAddress(e, item) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.addressDialog.addressInfo = item;
      this.addressDialog.type = 'edit';
      this.addressDialog.visible = true;
    },

    delModel(e, m) {
      sensorsdata.quick('trackHeatMap', e.target);
      utils.msgbox
        .confirm('是否确认删除该收货地址', '删除收货地址', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          Http.post('/peer_address_delete', {
            peer_address_id: m.peer_address_id,
          }).then(() => {
            this.getData();
            utils.msg.success('删除成功');
          }).catch((e) => {
            if (e) console.log(e);
          });
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },

    setDefault(e, m) {
      sensorsdata.quick('trackHeatMap', e.target);
      Http.post('/peer_address_set_default', {
        peer_address_id: m.peer_address_id,
      }).then(() => {
        this.getData();
        utils.msg.success('设置成功');
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    getAddress: addressUtils.getAddress,
    // 处理新增编辑地址
    handleEditAddressSuccess(addressInfo) {
      if (this.addressDialog.type === 'edit') {
        addressInfo.peer_address_id = this.addressDialog.addressInfo.peer_address_id;
      }
      Http.post(this.addressDialog.type === 'add' ? '/peer_address_add' : '/peer_address_update', addressInfo)
        .then(() => {
          utils.msg.success(this.type === 'add' ? '添加成功' : '编辑成功');
          this.addressDialog.visible = false;
          this.getData();
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/less/variable";
.address-page{
  padding: 24px;
  .page-content{
    .header{
      display: flex;
      justify-content: flex-end;
      .add-box{
        .add-btn{
        }
      }
    }
    .address-list{
      margin-top: 24px;
      display: flex;
      flex-wrap: wrap;
      line-height: 1;
      margin-right: -24px;
      .address-item-box{
        width: 274px;
        height: 145px;
        background: #FFFFFF;
        border-radius: 2px;
        border: 2px solid #E9EEF2;
        position: relative;
        margin-right: 24px;
        margin-bottom: 24px;
        &::before{
          content: "";
          background: url(../../../assets/imgs/new-user/address-bar.png) repeat center / 100% 100%;
          position: absolute;
          width: 100%;
          left: 0;
          top: 0;
          height: 2px;
        }
        .default-flag{
          width: 70px;
          height: 24px;
          background: url(../../../assets/imgs/new-user/default-bg.png) repeat center / 100% 100%;
          color: #fff;
          font-size: 12px;
          padding-left: 14px;
          display: flex;
          align-items: center;
          position: absolute;
          right: 0;
          top: 0;
        }
        .item-header{
          height: 40px;
          display: flex;
          align-items: center;
          padding: 0 80px 0 10px;
          background: #FAFBFC;
          .item-name{
            color: #2F333D;
            font-size: 14px;
            line-height: 24px;
            font-weight: 600;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .item-phone{
            margin-left: 8px;
            flex-shrink: 0;
            color: #91999F;
            font-size: 12px;
          }
        }
        .item-content{
          padding: 8px 10px;
          height: 74px;
          .item-address{
            color: #5F666E;
            font-size: 12px;
            line-height: 18px;
            overflow : hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            max-height: 36px;
          }
          .item-email{
            margin-top: 6px;
            display: flex;
            align-items: center;
            .icon{
              flex-shrink: 0;
              width: 12px;
              height: 12px;
              margin-right: 4px;
            }
            .text{
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 12px;
              line-height: 16px;
              color: #5F666E;
            }
          }
        }
        .item-footer{
          display: none;
          justify-content: flex-end;
          align-items: center;
          padding: 0 16px;
          .handler-item{
            display: flex;
            align-items: center;
            cursor: pointer;
            margin-left: 16px;
            .icon{
              width: 12px;
              height: 12px;
              margin-right: 2px;
              &.default{
                background: url(../../../assets/imgs/new-user/icon-set-default-gray.png) no-repeat center / 100% 100%;
              }
              &.edit{
                background: url(../../../assets/imgs/new-user/icon-edit-gray.png) no-repeat center / 100% 100%;
              }
              &.delete{
                background: url(../../../assets/imgs/new-user/icon-delete-gray.png) no-repeat center / 100% 100%;
              }
            }
            .text{
              color: #2F333D;
              font-size: 14px;
            }
            &:hover{
              .icon{
                &.default{
                  background: url(../../../assets/imgs/new-user/icon-set-default.png) no-repeat center / 100% 100%;
                }
                &.edit{
                  background: url(../../../assets/imgs/new-user/icon-edit.png) no-repeat center / 100% 100%;
                }
                &.delete{
                  background: url(../../../assets/imgs/new-user/icon-delete.png) no-repeat center / 100% 100%;
                }
              }
              .text{
                color:#599FFF;
              }
            }
          }

        }
        &:hover{
          .item-footer{
            display: flex;
          }
        }
      }
    }
  }

  .no-address{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
    .nodata-img{
      width: 200px;
      height: 120px;
    }
    .nodata-text{
      color: #91999F;
      font-size: 16px;
      margin-top: 12px;
    }
    .add-btn{
      margin-top: 16px;
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/pages/user/user-children/Address.vue